export type Language = {
  code: string;
  name: string;
};

export type LanguageType = "app" | "voice" | "voiceLang" | "simulation";

export const SUPPORTED_APP_LANGUAGES: Language[] = [
  { code: "en", name: "English" },
  { code: "zh-HK", name: "繁體中文" },
  { code: "zh-CN", name: "簡體中文" },
];

export const SUPPORTED_VOICE_LANGUAGES: Language[] = [
  { code: "en-US", name: "English" },
  { code: "zh-HK", name: "廣東話" },
  { code: "zh-CN", name: "普通話" },
];

export const DEFAULT_APP_LANGUAGE = "en";
export const DEFAULT_VOICE_LANGUAGE = "en-US";

export const SIMULATION_VOICE: Language[] = [
  { name: "Polly", code: "https://assets.deepworldmodel.ai/speech/polly" },
  { name: "Mark", code: "https://assets.deepworldmodel.ai/speech/labs" },
];
